// pages/Dlatrades/TradeRoutes.js
import React from 'react';
import { Routes, Route } from "react-router-dom";
import TradeLayout from './TradeLayout';
import DLAHeadlineSponsor from './tradepages/DLAHeadlineSponsor';
import SponsorshipOpportunities from './tradepages/SponsorshipOpportunities';
import DLATradeAwards from './tradepages/DLATradeAwards';
import AZDirectory from './tradepages/AZDirectory';
import BecomeAffiliateMember from './tradepages/BecomeAffiliateMember';
import DLATradeAwardsYear from './tradepages/DLATradeAwardsPage';

const TradeRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<TradeLayout />}>
        {/* Default Trade Landing (Cards Grid) */}
        <Route index element={<DLATradeAwards />} /> 
        
        {/* Main Sub-Pages */}
        <Route path="headline-sponsor" element={<DLAHeadlineSponsor />} />
        <Route path="sponsorship" element={<SponsorshipOpportunities />} />
        <Route path="awards" element={<DLATradeAwards />} />
        <Route path="directory" element={<AZDirectory />} />
        <Route path="become-member" element={<BecomeAffiliateMember />} />

        {/* Yearly Awards - USE DYNAMIC ROUTE */}
        <Route path="awards/:year" element={<DLATradeAwardsYear />} />
        
        {/* Keep the 2017 route for backward compatibility if needed */}
      </Route>
    </Routes>
  );
};

export default TradeRoutes;